import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ExpIconBottom from '../../ExpIconBottom';

import { makeStyles } from '@material-ui/styles';

import './cardPhotos.scss';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { marginTop } from 'styled-system';


const useStyles = makeStyles({

  modal: {

    background: 'rgba( 1, 57, 87, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex:'999999999999 !important'
  },
});


function CardPhotos(props) {

  const { authClient, publicImgViews } = props

  const displaysm = useMediaQuery('(max-width:425px)');

  const [modal_image, setModalImage] = useState();
  const [open, setOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState(null);


 // const [expansionButton, setExpansionButton] = useState(false);


  const classes = useStyles();

  const handleModal = (image) => {
    setModalImage(image)
    setOpen(true);

  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const toggleModal = (index) => {
    setCurrentModal(index)
    setOpen(!open)
  };

  let arrImages = authClient && authClient.imgViews ? authClient.imgViews.slice() : publicImgViews ? publicImgViews.slice() : []

  return (
    <>
      <div className='picturePreview'>
        <ExpIconBottom
          title="Galería de fotos"
          sumcontent={

            <div className="picturePreview_PictureProfile">
              {arrImages.map((picture, index) => {

                if(index <= 3 ){
                  return(
                    <div key={index} className="picturePreview_Picture-1" >
                      <img
                            src={picture.src}
                            alt=""
                            onClick={()=>{toggleModal(index)}}
                          />
                     </div>
                  )
                }


              }
              )}
            </div>
          }
          detcontent={
            <div style={{marginTop:16}}>
              <div className="picturePreview_PictureProfile">
                {arrImages.map((picture, index) => {
                  if(index >= 4 ){
                    return(
                      <div key={index} className="picturePreview_Picture-1" >
                        <img
                          src={picture.src}
                          alt=""
                          onClick={()=>{toggleModal(index)}}
                        />
                      </div>
                    )
                  }
                }
                )}
              </div>
            </div>
          }
          expansionButton={arrImages.length > 4 ? true : false}
        />


      <ModalGateway>
        {open ? (
          <Modal onClose={toggleModal}   
            styles={{
            blanket: base => ({
              ...base,
              backgroundColor: 'rgba(1, 57, 87, 0.7)',
            })}}
            >
            <Carousel views={arrImages} currentIndex={currentModal} />
          </Modal>
        ) : null}
      </ModalGateway>
      </div>
    </>
  );
}

export default CardPhotos;
